// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vTdf","input":"styles_input__3tqpN"};